import { Avatar } from "@atoms/index"

import { UserAvatarProps } from "./UserAvatar.types"

export default function UserAvatar(props: UserAvatarProps) {
    const { user, ...rest } = props

    return <Avatar variant="user" fallbackName={user?.full_name} src={user?.avatar || user?.gravatar} {...rest} />
}
